module.exports = "/assets/footer/rewards/brief.png?PBSL/eK";